<template>
    <div>
        <!-- Modal Rateio -->
        <div class="modal fade" :id="modal_name" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            Regra de Rateio 
                            <small class="text-muted" v-if="rateio && rateio.medico">
                                de {{ rateio.medico.st_nome_exibicao }}
                            </small>
                            <span class="badge badge-secondary mx-2" v-if="rateio && rateio.id_rateio_medico">
                                #{{ rateio.id_rateio_medico }}
                            </span>
                            <span class="badge badge-primary" v-if="rateio && rateio.fl_especifico">Específico</span>
                            <span class="badge badge-danger" v-else-if="rateio && !rateio.fl_ativo">Inativo</span>

                            <span class="ml-3" v-if="viewonly">
                                <i class="fa-solid fa-eye"></i>
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <az-empty-state msg="Localizando Rateio..." v-if="!rateio" />

                        <template v-if="rateio">
                            <div class="form-row">
                                <div class="col col-12 col-md-10">
                                    <div id="rateio-titulo">
                                        <az-input
                                            sizing="sm"
                                            label="Título"
                                            v-model="rateio.st_titulo" />
                                    </div>
                                </div>

                                <div class="col col-12 col-md-2">
                                    <div id="rateio-titulo">
                                        <az-input
                                            sizing="sm"
                                            label="Ordem"
                                            v-model="rateio.in_regra_ordem" />
                                    </div>
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="col col-12 col-md-4">
                                    <div id="rateio-vigencia">
                                        <az-input 
                                            sizing="sm"
                                            label="Data para Início da Vigência"
                                            type="date"
                                            required 
                                            :validate="validate"
                                            v-model="rateio.dt_data_vigencia" />
                                    </div>
                                </div>
                                <div class="col col-12 col-md-4">
                                    <div id="rateio-referencia">
                                        <az-input 
                                            sizing="sm" 
                                            label="Referência"
                                            type="select"
                                            optionsMode="json"
                                            :optionsList="lista_tipo_criterio"
                                            optionsData="id"
                                            optionsDisplay="search"
                                            name="rateio-referencia"
                                            required 
                                            :validate="validate"
                                            v-model="rateio.ch_tipo_repasse" />
                                    </div>
                                </div>
                                <div class="col col-12 col-md-4">
                                    <az-input
                                        sizing="sm"
                                        v-if="rateio.ch_tipo_repasse == 'M'"
                                        placeholder="Tempo em dias..."
                                        required 
                                        label="Dias para Pagamento pelo Produzido"
                                        v-model="rateio.in_dias_para_pagamento"
                                        :validate="validate">
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append">
                                                <span class="input-group-text" id="basic-addon2">
                                                    dias
                                                </span>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>
                            </div>

                            <div class="form-row" v-if="rateio.id_classe_procedimento || rateio.id_procedimento">
                                <div class="col col-12 col-md-4">
                                    <az-input 
                                        sizing="sm"
                                        label="Classificação"
                                        service="classe_procedimentos.index"
                                        type="select"
                                        optionsMode="aql"
                                        :optionsSync="false"
                                        optionsData="id_classe_procedimento"
                                        optionsDisplay="search"
                                        :validate="validate"
                                        :edicao="!rateio.id_procedimento"
                                        v-model="rateio.id_classe_procedimento" />
                                </div>
                                <div class="col col-12 col-md-8">
                                    <az-input 
                                        sizing="sm"
                                        label="Procedimento"
                                        :validate="validate"
                                        type="autocomplete"
                                        service="procedimentos.index"
                                        optionsData="id_procedimento"
                                        optionsDisplay="search"
                                        :required="rateio.valor_fixo"
                                        :optionsParm="{ id_medico: id_medico }"
                                        :optionsInitial="rateio.procedimento ? rateio.procedimento.search : ''"
                                        :edicao="!rateio.id_classe_procedimento"
                                        v-model="rateio.id_procedimento" />
                                </div>
                            </div>

                            <!-- RATEIO DO VALOR -->

                            <div class="card mt-3">
                                <div class="card-header alert-info">
                                    <a class="card-link" data-toggle="collapse" href="#collapseRegra">
                                        Rateio do Valor
                                    </a>
                                </div>
                                <div class="card-body collapse show" id="collapseRegra">
                                    <!-- Procedimento -->
                                    <div class="form-row">
                                        <div class="col col-12 col-md-2">
                                            <az-input   
                                                label="Tipo"
                                                sizing="sm"
                                                :edicao="false"
                                                value="Procedimento" />
                                        </div>

                                        <div class="col col-12 col-md-2" id="rateio-valor-fixo">
                                            <az-input   
                                                label="Rateio"
                                                sizing="sm"
                                                type="select"
                                                :optionsList="[
                                                    { id: 0, search: 'Percentual' },
                                                    { id: 1, search: 'Valor Fixo Profissional' },
                                                    { id: 2, search: 'Valor Fixo Clínica' },
                                                    { id: 3, search: 'Valor Único Profissional' },
                                                ]"
                                                optionsData="id"
                                                v-model="rateio.valor_fixo" />
                                        </div>
                                        <div class="col col-12 col-md-2" v-if="rateio.valor_fixo">
                                            <az-input
                                                label="Valor Fixo"
                                                sizing="sm"
                                                icon="fa-solid fa-brazilian-real-sign fa-fw"
                                                type="money"
                                                :validate="validate"
                                                v-model="rateio.dc_valor_medico" />
                                        </div>
                                        <template v-else>
                                            <div class="col col-12 col-md-2">
                                                <az-input
                                                    label="Percentual"
                                                    sizing="sm"
                                                    icon="fas fa-percent fa-fw"
                                                    type="money"
                                                    :validate="validate"
                                                    v-model="rateio.dc_porcentagem_medico" />
                                            </div>
                                        </template>

                                        <div class="col col-12 col-md-4">
                                            <div id="rateio-aliquota">
                                                <az-input
                                                    sizing="sm"
                                                    icon="fas fa-percent fa-fw"
                                                    label="% da Alíquota de Retenção"
                                                    type="money"
                                                    :validate="validate"
                                                    v-model="rateio.dc_porcentagem_aliquota" />
                                            </div>
                                        </div>
                                        
                                    </div>

                                    <!-- Mat/Med/Taxa v-if="!rateio.valor_fixo"> -->

                                    <template>

                                        <!-- Taxa -->
                                        <div class="form-row">
                                            <div class="col col-12 col-md-2">
                                                <az-input   
                                                    sizing="sm"
                                                    :edicao="false"
                                                    value="Taxas" />
                                            </div>

                                            <div class="col col-12 col-md-2">
                                                <az-input   
                                                    sizing="sm"
                                                    type="select"
                                                    :optionsList="[
                                                        { id: 0, search: 'Percentual' },
                                                        { id: 1, search: 'Valor Fixo Profissional' },
                                                        { id: 2, search: 'Valor Fixo Clínica' },
                                                        { id: 3, search: 'Definição por Item' },
                                                    ]"
                                                    optionsData="id"
                                                    v-model="rateio.fl_taxa_valor_fixo" />
                                            </div>

                                            <div class="col col-12 col-md-2">
                                                <az-input
                                                    v-if="!rateio.fl_taxa_valor_fixo"
                                                    icon="fas fa-percent fa-fw"
                                                    sizing="sm"
                                                    type="money"
                                                    :validate="validate"
                                                    v-model="rateio.dc_porcentagem_taxa" />

                                                <az-input
                                                    v-else-if="rateio.fl_taxa_valor_fixo != 3"
                                                    icon="fa-solid fa-brazilian-real-sign fa-fw"
                                                    sizing="sm"
                                                    type="money"
                                                    :validate="validate"
                                                    v-model="rateio.dc_valor_taxa" />
                                            </div>

                                            <template v-if="!rateio.fl_sem_imp_consumo">
                                                <div class="col col-12" :class="rateio.fl_aliquota_taxa ? 'col-md-2' : 'col-md-4'">
                                                    <az-input
                                                        sizing="sm"
                                                        type="checkbox-group"
                                                        label="Outra Alíquota"
                                                        v-model="rateio.fl_aliquota_taxa" />
                                                </div>
                                                <div class="col col-12 col-md-2" v-if="rateio.fl_aliquota_taxa">
                                                    <az-input
                                                        icon="fas fa-percent fa-fw"
                                                        sizing="sm"
                                                        type="money"
                                                        :validate="validate"
                                                        v-model="rateio.dc_aliquota_taxa" />
                                                </div>
                                            </template>
                                        </div>

                                        <!-- Materiais -->
                                        <div class="form-row">
                                            <div class="col col-12 col-md-2">
                                                <az-input   
                                                    sizing="sm"
                                                    :edicao="false"
                                                    value="Materiais" />
                                            </div>
                                            <div class="col col-12 col-md-2">
                                                <az-input   
                                                    sizing="sm"
                                                    type="select"
                                                    :optionsList="[
                                                        { id: 0, search: 'Percentual' },
                                                        { id: 1, search: 'Valor Fixo Profissional' },
                                                        { id: 2, search: 'Valor Fixo Clínica' },
                                                        { id: 3, search: 'Definição por Item' },
                                                    ]"
                                                    optionsData="id"
                                                    v-model="rateio.fl_mat_valor_fixo" />
                                            </div>
                                            <div class="col col-12 col-md-2">
                                                <az-input
                                                    v-if="!rateio.fl_mat_valor_fixo"
                                                    sizing="sm"
                                                    icon="fas fa-percent fa-fw"
                                                    type="money"
                                                    :validate="validate"
                                                    v-model="rateio.dc_porcentagem_mat" />

                                                <az-input
                                                    v-else-if="rateio.fl_mat_valor_fixo != 3"
                                                    icon="fa-solid fa-brazilian-real-sign fa-fw"
                                                    sizing="sm"
                                                    type="money"
                                                    :validate="validate"
                                                    v-model="rateio.dc_valor_mat" />
                                            </div>

                                            <template v-if="!rateio.fl_sem_imp_consumo">
                                                <div class="col col-12" :class="rateio.fl_aliquota_mat ? 'col-md-2' : 'col-md-4'">
                                                    <az-input
                                                        sizing="sm"
                                                        type="checkbox-group"
                                                        label="Outra Alíquota"
                                                        v-model="rateio.fl_aliquota_mat" />
                                                </div>
                                                <div class="col col-12 col-md-2" v-if="rateio.fl_aliquota_mat">
                                                    <az-input
                                                        icon="fas fa-percent fa-fw"
                                                        sizing="sm"
                                                        type="money"
                                                        :validate="validate"
                                                        v-model="rateio.dc_aliquota_mat" />
                                                </div>
                                            </template>
                                        </div>

                                        <!-- Medicamentos -->
                                        <div class="form-row">
                                            <div class="col col-12 col-md-2">
                                                <az-input   
                                                    sizing="sm"
                                                    :edicao="false"
                                                    value="Medicamentos" />
                                            </div>
                                            <div class="col col-12 col-md-2">
                                                <az-input   
                                                    sizing="sm"
                                                    type="select"
                                                    :optionsList="[
                                                        { id: 0, search: 'Percentual' },
                                                        { id: 1, search: 'Valor Fixo Profissional' },
                                                        { id: 2, search: 'Valor Fixo Clínica' },
                                                        { id: 3, search: 'Definição por Item' },
                                                    ]"
                                                    optionsData="id"
                                                    v-model="rateio.fl_med_valor_fixo" />
                                            </div>
                                            <div class="col col-12 col-md-2">
                                                <az-input
                                                    v-if="!rateio.fl_med_valor_fixo"
                                                    sizing="sm"
                                                    icon="fas fa-percent fa-fw"
                                                    type="money"
                                                    :validate="validate"
                                                    v-model="rateio.dc_porcentagem_med" />

                                                <az-input
                                                    v-else-if="rateio.fl_med_valor_fixo != 3"
                                                    icon="fa-solid fa-brazilian-real-sign fa-fw"
                                                    sizing="sm"
                                                    type="money"
                                                    :validate="validate"
                                                    v-model="rateio.dc_valor_med" />
                                            </div>

                                            <template v-if="!rateio.fl_sem_imp_consumo">
                                                <div class="col col-12" :class="rateio.fl_aliquota_med ? 'col-md-2' : 'col-md-4'">
                                                    <az-input
                                                        sizing="sm"
                                                        type="checkbox-group"
                                                        label="Outra Alíquota"
                                                        v-model="rateio.fl_aliquota_med" />
                                                </div>
                                                <div class="col col-12 col-md-2" v-if="rateio.fl_aliquota_med">
                                                    <az-input
                                                        icon="fas fa-percent fa-fw"
                                                        sizing="sm"
                                                        type="money"
                                                        :validate="validate"
                                                        v-model="rateio.dc_aliquota_med" />
                                                </div>
                                            </template>
                                        </div>

                                    </template>

                                    <!-- Valor Fixo --> 

                                    <div v-if="rateio.valor_fixo > 0">
                                        <az-sub-title title="Valor Fixo por Procedimento" class="mt-3">
                                            <a class="card-link" v-if="!viewonly || rateio.fl_especifico" href="#" @click.prevent="incluirRegraFixo (rateio)">
                                                <i class="fas fa-plus mr-2"></i>
                                                Incluir Procedimento
                                            </a>
                                        </az-sub-title>

                                        <template v-for="(rmf, imf) in rateio.rateio_medico_fixos">
                                            <div class="form-row" :key="imf" v-show="!rmf.excluido" v-if="true">
                                                <div class="col col-12 col-md-9">
                                                    <az-input
                                                        sizing="sm"
                                                        :edicao="false"
                                                        v-if="rmf.id_rateio_medico_fixo || rmf.procedimento"
                                                        v-model="rmf.procedimento.search">
                                                        <template v-slot:button-pre>
                                                            <div class="input-group-prepend">
                                                                <button class="btn btn-outline-danger" type="button" @click="rmf.excluido = true">
                                                                    <i class="fa fa-minus" aria-hidden="true"></i>
                                                                </button>
                                                            </div>
                                                        </template>
                                                    </az-input>

                                                    <az-input
                                                        v-else
                                                        sizing="sm"
                                                        type="autocomplete"
                                                        placeholder="Procedimento..."
                                                        :validate="validate"
                                                        service="procedimentos.index"
                                                        optionsData="id_procedimento"
                                                        optionsDisplay="search"
                                                        required 
                                                        v-model="rmf.id_procedimento">
                                                        <template v-slot:button-pre>
                                                            <div class="input-group-prepend">
                                                                <button class="btn btn-outline-danger" type="button" @click="rmf.excluido = true">
                                                                    <i class="fa fa-minus" aria-hidden="true"></i>
                                                                </button>
                                                            </div>
                                                        </template>
                                                    </az-input>
                                                </div>

                                                <div class="col col-12 col-md-3">
                                                    <az-input
                                                        type="money"
                                                        sizing="sm"
                                                        icon="fa-solid fa-brazilian-real-sign"
                                                        placeholder="Valor Fixo..."
                                                        v-model="rmf.dc_valor" />
                                                </div>
                                            </div>
                                        </template>
                                    </div>

                                    <!-- Valor Fixo para Consumo (Mat/Med/Taxa) -->
                                    <div v-if="rateio.fl_med_valor_fixo == 3 || rateio.fl_mat_valor_fixo == 3 || rateio.fl_taxa_valor_fixo == 3 || ( ( rateio.fl_comissao_fixo || rateio.fl_comissao_consumo ) && rateio.ch_solic_consumo == 3 )">
                                        <az-sub-title title="Valor Repasse por Mat/Med/Taxa" class="mt-3">
                                            <a class="card-link" v-if="!viewonly || rateio.fl_especifico" href="#" @click.prevent="incluirRegraFixoConsumo (rateio)">
                                                <i class="fas fa-plus mr-2"></i>
                                                Incluir Item
                                            </a>
                                        </az-sub-title>

                                        <div class="form-row" v-if="rateio.rateio_medico_fixo_consumos.length">
                                            <div class="col col-12 col-md-2">
                                                <small class="text-muted">Tipo</small>  
                                            </div>
                                            <div class="col col-12 col-md-6">
                                                <small class="text-muted">Item</small>  
                                            </div>
                                            <div class="col col-12 col-md-2">
                                                <small class="text-muted">Prestador</small>  
                                            </div>
                                            <div class="col col-12 col-md-2">
                                                <small class="text-muted">Solicitante</small>  
                                            </div>
                                        </div>
                                            
                                        <template v-for="(rmf, imf) in rateio.rateio_medico_fixo_consumos">
                                            <div class="form-row" :key="imf" v-show="!rmf.excluido" v-if="true">
                                                <div class="col col-12 col-md-2">
                                                    <az-input   
                                                        sizing="sm"
                                                        type="select"
                                                        :optionsList="[
                                                            { id: 'C', search: 'Classificação do Item' }, 
                                                            { id: 'I', search: 'Item' }, 
                                                        ]"
                                                        optionsData="id"
                                                        :edicao="!rmf.id_rateio_medico_fixo_consumo && !rmf.search"
                                                        v-model="rmf.ch_tipo" />
                                                </div>
                                                <div class="col col-12 col-md-6">
                                                    <az-input
                                                        sizing="sm"
                                                        :edicao="false"
                                                        v-if="rmf.id_rateio_medico_fixo_consumo || rmf.search"
                                                        v-model="rmf.search">
                                                        <template v-slot:button-pre>
                                                            <div class="input-group-prepend">
                                                                <button class="btn btn-outline-danger" type="button" @click="rmf.excluido = true">
                                                                    <i class="fa fa-minus" aria-hidden="true"></i>
                                                                </button>
                                                            </div>
                                                        </template>
                                                    </az-input>

                                                    <az-input
                                                        v-else-if="rmf.ch_tipo == 'I'"
                                                        sizing="sm"
                                                        placeholder="Selecione material, medicamento ou taxa..."
                                                        type="autocomplete"
                                                        optionsMode="aql"
                                                        optionsName="consumo.index"
                                                        service="consumo.index"
                                                        :optionsSync="true"
                                                        v-model="rmf.consumo">
                                                        <template v-slot:button-pre>
                                                            <div class="input-group-prepend">
                                                                <button class="btn btn-outline-danger" type="button" @click="rmf.excluido = true">
                                                                    <i class="fa fa-minus" aria-hidden="true"></i>
                                                                </button>
                                                            </div>
                                                        </template>
                                                    </az-input>

                                                    <az-input
                                                        v-else-if="rmf.ch_tipo == 'C'"
                                                        sizing="sm"
                                                        placeholder="Selecione a classificação do item..."
                                                        type="select"
                                                        :optionsList="lista_tag_consumo"
                                                        optionsData="id"
                                                        required
                                                        :validate="validate"
                                                        v-model="rmf.st_classe">
                                                        <template v-slot:button-pre>
                                                            <div class="input-group-prepend">
                                                                <button class="btn btn-outline-danger" type="button" @click="rmf.excluido = true">
                                                                    <i class="fa fa-minus" aria-hidden="true"></i>
                                                                </button>
                                                            </div>
                                                        </template>
                                                    </az-input>
                                                </div>

                                                <div class="col col-12 col-md-2">
                                                    <az-input
                                                        v-if="rateio.fl_med_valor_fixo || rateio.fl_mat_valor_fixo || rateio.fl_taxa_valor_fixo"
                                                        type="money"
                                                        sizing="sm"
                                                        v-model="rmf.dc_valor">
                                                        <template v-slot:button-pre>
                                                            <div class="input-group-append">
                                                                <button class="btn btn-sm btn-outline-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                                    <i class="fa-solid fa-brazilian-real-sign fa-fw" v-if="rmf.ch_tipo_calc == 'V' || rmf.ch_tipo_calc == 'Q'"></i>
                                                                    <i class="fas fa-percent fa-fw" v-else-if="rmf.ch_tipo_calc == 'P'"></i>
                                                                    <i class="fa-solid fa-question fa-fw" v-else></i>

                                                                    <span v-if="rmf.ch_tipo_calc == 'Q'" class="ml-2">x</span>
                                                                </button>
                                                                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                                    <a class="dropdown-item" href="#" @click.prevent="rmf.ch_tipo_calc = 'V'">
                                                                        <i class="fa-solid fa-brazilian-real-sign fa-fw mr-2"></i>
                                                                        Valor Fixo
                                                                    </a>
                                                                    <a class="dropdown-item" href="#" @click.prevent="rmf.ch_tipo_calc = 'Q'">
                                                                        <i class="fa-solid fa-brazilian-real-sign fa-fw mr-2"></i>
                                                                        Valor Fixo (x Qtd)
                                                                    </a>
                                                                    <a class="dropdown-item" href="#" @click.prevent="rmf.ch_tipo_calc = 'P'">
                                                                        <i class="fas fa-percent fa-fw mr-2"></i>
                                                                        Percentual
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </template>
                                                    </az-input>
                                                </div>

                                                <div class="col col-12 col-md-2">
                                                    <az-input
                                                        v-if="( rateio.fl_comissao_fixo || rateio.fl_comissao_consumo ) && rateio.ch_solic_consumo == 3"
                                                        type="money"
                                                        sizing="sm"
                                                        v-model="rmf.dc_valor_solic">
                                                        <template v-slot:button-pre>
                                                            <div class="input-group-append">
                                                                <button class="btn btn-sm btn-outline-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                                    <i class="fa-solid fa-brazilian-real-sign fa-fw" v-if="rmf.ch_tipo_calc_solic == 'V' || rmf.ch_tipo_calc_solic == 'Q'"></i>
                                                                    <i class="fas fa-percent fa-fw" v-else-if="rmf.ch_tipo_calc_solic == 'P'"></i>
                                                                    <i class="fa-solid fa-question fa-fw" v-else></i>

                                                                    <span v-if="rmf.ch_tipo_calc_solic == 'Q'" class="ml-2">x</span>
                                                                </button>
                                                                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                                    <a class="dropdown-item" href="#" @click.prevent="rmf.ch_tipo_calc_solic = 'V'">
                                                                        <i class="fa-solid fa-brazilian-real-sign fa-fw mr-2"></i>
                                                                        Valor Fixo
                                                                    </a>
                                                                    <a class="dropdown-item" href="#" @click.prevent="rmf.ch_tipo_calc_solic = 'Q'">
                                                                        <i class="fa-solid fa-brazilian-real-sign fa-fw mr-2"></i>
                                                                        Valor Fixo (x Qtd)
                                                                    </a>
                                                                    <a class="dropdown-item" href="#" @click.prevent="rmf.ch_tipo_calc_solic = 'P'">
                                                                        <i class="fas fa-percent fa-fw mr-2"></i>
                                                                        Percentual
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </template>
                                                    </az-input>
                                                </div>
                                            </div>
                                        </template>
                                    </div>

                                    <!-- Outras Configurações -->

                                    <az-sub-title title="Outras Configurações" class="mt-3">
                                    </az-sub-title>

                                    <div class="form-row">

                                        <!-- Filme -->

                                        <div class="col col-12" :class="rateio.fl_abater_filme ? 'col-md-3' : 'col-md-4'">
                                            <az-input
                                                sizing="sm"
                                                label="Abater valor do filme"
                                                type="checkbox-group"
                                                :validate="validate"
                                                v-model="rateio.fl_abater_filme"/>
                                        </div>

                                        <div class="col col-12 col-md-1" v-if="rateio.fl_abater_filme">
                                            <az-input
                                                sizing="sm"
                                                icon="fa fa-percent"
                                                type="number"
                                                :validate="validate"
                                                v-model="rateio.dc_perc_ret_filme"/>
                                        </div>

                                        <!-- Custo Operacional -->

                                        <div class="col col-12" :class="rateio.fl_abater_co ? 'col-md-3' : 'col-md-4'">
                                            <div>
                                                <az-input
                                                    sizing="sm"
                                                    label="Abater Custo Operacional (UCO)"
                                                    type="checkbox-group"
                                                    :validate="validate"
                                                    v-model="rateio.fl_abater_co" />
                                            </div>
                                        </div>

                                        <div class="col col-12 col-md-1" v-if="rateio.fl_abater_co">
                                            <az-input
                                                sizing="sm"
                                                icon="fa fa-percent"
                                                type="number"
                                                :validate="validate"
                                                v-model="rateio.dc_perc_ret_co"/>
                                        </div>

                                        <!-- Honorário -->

                                        <div class="col col-12" :class="rateio.fl_abater_hon ? 'col-md-3' : 'col-md-4'">
                                            <div>
                                                <az-input
                                                    sizing="sm"
                                                    label="Abater Honorário"
                                                    type="checkbox-group"
                                                    :validate="validate"
                                                    v-model="rateio.fl_abater_hon" />
                                            </div>
                                        </div>

                                        <div class="col col-12 col-md-1" v-if="rateio.fl_abater_hon">
                                            <az-input
                                                sizing="sm"
                                                icon="fa fa-percent"
                                                type="number"
                                                :validate="validate"
                                                v-model="rateio.dc_perc_ret_hon"/>
                                        </div>
                                    </div>

                                    <div class="form-row mt-1">
                                        <div class="col col-12 col-md-8">
                                            <div id="rateio-pacote">
                                                <az-input
                                                    sizing="sm"
                                                    label="Pacote de Sessões (Repasse Individual)"
                                                    type="checkbox-group"
                                                    :validate="validate"
                                                    v-model="rateio.fl_pacote_sessao_individual" />
                                            </div>
                                        </div>
                                        <div class="col col-12 col-md-4" v-if="rateio.ch_tipo_repasse == 'R' || rateio.ch_tipo_repasse == 'F'">
                                            <az-input
                                                sizing="sm"
                                                label="Abater taxa do cartão"
                                                type="checkbox-group"
                                                :validate="validate"
                                                v-model="rateio.fl_abater_taxa_cartao" />
                                        </div>
                                    </div>

                                    <div class="form-row" v-if="rateio.ch_tipo_repasse == 'P' || rateio.valor_fixo">
                                        <div class="col col-12 col-md-8">
                                            <div>
                                                <az-input
                                                    sizing="sm"
                                                    label="Abater desconto particular"
                                                    type="checkbox-group"
                                                    :validate="validate"
                                                    v-model="rateio.fl_abater_desconto_particular" />
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="col col-12 col-md-8">
                                            <div>
                                                <az-input
                                                    sizing="sm"
                                                    label="Não abater Retenção em Mat/Med/Taxas"
                                                    type="checkbox-group"
                                                    :validate="validate"
                                                    v-model="rateio.fl_sem_imp_consumo" />
                                            </div>
                                        </div>
                                        <div class="col col-12 col-md-4" v-if="rateio.fl_abater_taxa_cartao">
                                            <div>
                                                <az-input
                                                    sizing="sm"
                                                    label="Não abater taxa do cartão em Mat/Med/Taxas"
                                                    type="checkbox-group"
                                                    :validate="validate"
                                                    v-model="rateio.fl_sem_taxa_cartao_consumo" />
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="col col-12 col-md-8">
                                            <div>
                                                <az-input
                                                    sizing="sm"
                                                    label="Regra de Devolução (Valor recebido diretamente pelo profissional)"
                                                    type="checkbox-group"
                                                    :validate="validate"
                                                    v-model="rateio.fl_devolucao" />
                                            </div>
                                        </div>
                                        <div class="col col-12 col-md-4" v-if="rateio.fl_devolucao">
                                            <div>
                                                <az-input
                                                    sizing="sm"
                                                    label="Devolução somente do procedimento"
                                                    type="checkbox-group"
                                                    :validate="validate"
                                                    v-model="rateio.fl_devolucao_so_proced" />
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="col col-12 col-md-8">
                                            <div>
                                                <az-input
                                                    sizing="sm"
                                                    label="Repasse do item, mesmo quando dentro de pacote de procedimento"
                                                    type="checkbox-group"
                                                    :validate="validate"
                                                    v-model="rateio.fl_empacotado" />
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="col col-12 col-md-8">
                                            <div>
                                                <az-input
                                                    sizing="sm"
                                                    label="Apenas Laudos Prontos"
                                                    type="checkbox-group"
                                                    :validate="validate"
                                                    v-model="rateio.fl_laudo_pronto" />
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-row" v-if="rateio.valor_fixo > 0">
                                        <div class="col col-12 col-md-8">
                                            <div>
                                                <az-input
                                                    sizing="sm"
                                                    label="Repasse do item, mesmo quando valor zerado"
                                                    type="checkbox-group"
                                                    :validate="validate"
                                                    v-model="rateio.fl_zerado" />
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="col col-12 col-md-8">
                                            <az-input
                                                sizing="sm"
                                                label="Repasse dos materiais baseado no preço da última entrada"
                                                type="checkbox-group"
                                                :validate="validate"
                                                v-model="rateio.fl_mat_pue" />
                                        </div>
                                        <div class="col col-12 col-md-4" v-if="rateio.fl_mat_pue">
                                            <az-input
                                                sizing="sm"
                                                type="checkbox-group"
                                                label="Pelo Lucro"
                                                :validate="validate"
                                                v-model="rateio.fl_mat_pue_lucro" />
                                        </div>
                                    </div>

                                    <div class="card" v-if="1==1 || rateio.fl_mat_pue">
                                        <div class="card-header alert-secondary py-1">
                                            <a class="card-link" data-toggle="collapse" href="#collapseInfoConsumo">
                                                Fator de Multiplicação para Materiais
                                            </a>
                                        </div>
                                        <div class="card-body collapse py-2" id="collapseInfoConsumo">
                                            <div class="form-row">
                                                <div class="col col-12 col-md-6">
                                                    <az-input
                                                        label="Fator Multiplicação no Preço"
                                                        sizing="sm"
                                                        icon="fa-solid fa-xmark"
                                                        placeholder="Nenhum..."
                                                        type="number"
                                                        :validate="validate"
                                                        v-model="rateio.dc_fator_pue" />
                                                </div>

                                                <template v-if="false">
                                                    <div class="col col-12 col-md-2" v-if="rateio.dc_fator_pue">
                                                        <az-input
                                                            label="Ação"
                                                            sizing="sm"
                                                            placeholder="Aplicar"
                                                            type="select"
                                                            :optionsList="[
                                                                { id: 'R', search: 'Reter' }, 
                                                            ]"
                                                            optionsData="id"
                                                            :validate="validate"
                                                            v-model="rateio.st_acao_fator_pue" />
                                                    </div>

                                                    <div class="col col-12 col-md-4" v-if="rateio.dc_fator_pue && rateio.st_acao_fator_pue == 'R'"> 
                                                        <az-input
                                                            label="Título..."
                                                            sizing="sm"
                                                            placeholder="Informar..."
                                                            :validate="validate"
                                                            v-model="rateio.st_fator_pue" />
                                                    </div>
                                                </template>
                                            </div>

                                            <div class="form-row">
                                                <div class="col col-12 col-md-6">
                                                    <az-input
                                                        label="Fator de Multiplicação na Base (Produzido/Pago/Recebido)"
                                                        sizing="sm"
                                                        icon="fa-solid fa-xmark"
                                                        placeholder="Nenhum..."
                                                        type="number"
                                                        :validate="validate"
                                                        v-model="rateio.dc_fator_base_pue" />
                                                </div>

                                                <div class="col col-12 col-md-2" v-if="rateio.dc_fator_base_pue">
                                                    <az-input
                                                        label="Ação"
                                                        sizing="sm"
                                                        placeholder="Aplicar"
                                                        type="select"
                                                        :optionsList="[
                                                            { id: 'R', search: 'Reter' }, 
                                                        ]"
                                                        optionsData="id"
                                                        :validate="validate"
                                                        v-model="rateio.st_acao_fator_base_pue" />
                                                </div>

                                                <div class="col col-12 col-md-4" v-if="rateio.dc_fator_base_pue && rateio.st_acao_fator_base_pue == 'R'"> 
                                                    <az-input
                                                        label="Título..."
                                                        sizing="sm"
                                                        placeholder="Informar..."
                                                        :validate="validate"
                                                        v-model="rateio.st_fator_base_pue" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Abater Consumo do Procedimento -->
                                    <div class="form-row" v-if="rateio.valor_fixo === 0 
                                            && ( 
                                                ( !rateio.fl_mat_valor_fixo && rateio.dc_porcentagem_mat < 0 ) 
                                                || ( !rateio.fl_med_valor_fixo && rateio.dc_porcentagem_med < 0 )
                                                || ( !rateio.fl_taxa_valor_fixo && rateio.dc_porcentagem_taxa < 0 ) 
                                            )">
                                        <div class="col col-12 col-md-8">
                                            <div>
                                                <az-input
                                                    sizing="sm"
                                                    label="Abater valor do mat/med/taxa do valor do procedimento"
                                                    type="checkbox-group"
                                                    :validate="validate"
                                                    v-model="rateio.fl_abater_consumo_proc" />
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <!-- Retenções por Forma de Pagamento -->
                                    <template v-if="rateio && ( rateio.ch_tipo_repasse == 'F' || rateio.ch_tipo_repasse == 'R' )">
                                        <az-sub-title title="Regra por Forma de Pagamento" class="mt-3" id="rateio-retencao-forma">
                                            <a class="card-link" v-if="!viewonly || rateio.fl_especifico" href="#" @click.prevent="incluirRegraRetencao (rateio)">
                                                <i class="fas fa-plus mr-2"></i>
                                                Incluir Regra
                                            </a>
                                        </az-sub-title>

                                        <div class="row" v-if="!rateio.js_ret_imp_forma || !rateio.js_ret_imp_forma.length">
                                            <div class="col col-12">
                                                <span class="text-muted">
                                                    Nenhuma Regra Específica
                                                </span>
                                            </div>
                                        </div>

                                        <div v-else>
                                            <div class="form-row" v-for="(rat_imp, iix) in rateio.js_ret_imp_forma" :key="iix">
                                                <div class="col col-12 col-md-6">
                                                    <az-input
                                                        :label="iix ? '' : 'Forma de Pagamento'"
                                                        placeholder="Forma de Pagamento..."
                                                        sizing="sm"
                                                        icon="fas fa-minus"
                                                        :buttonIcon="true"
                                                        buttonText="fas fa-minus"
                                                        @clickButton="remover_item(rateio.js_ret_imp_forma, iix)"
                                                        buttonColor="outline-danger"
                                                        type="select"
                                                        optionsMode="aql"
                                                        optionsData="id_forma_pagamento"
                                                        service="forma_pagamentos.index"
                                                        required 
                                                        :validate="validate"
                                                        v-model="rat_imp.id_forma_pagamento" />
                                                </div>
                                                <div class="col col-12 col-md-3">
                                                    <az-input
                                                        :label="iix ? '' : 'Repasse'"
                                                        sizing="sm"
                                                        icon="fas fa-percent"
                                                        placeholder="% de Repasse"
                                                        :type="removendo_item ? 'number' : 'money'"
                                                        :validate="validate"
                                                        v-model="rat_imp.dc_porcentagem_medico" />
                                                </div>
                                                <div class="col col-12 col-md-3">
                                                    <az-input
                                                        :label="iix ? '' : 'Retenção'"
                                                        sizing="sm"
                                                        icon="fas fa-percent"
                                                        placeholder="% da Alíquota de Retenção"
                                                        :type="removendo_item ? 'number' : 'money'"
                                                        :validate="validate"
                                                        v-model="rat_imp.dc_porcentagem_aliquota" />
                                                </div>
                                            </div>

                                            <pre v-if="false">{{ rateio.js_ret_imp_forma }}</pre>
                                        </div>
                                    </template>

                                    <!-- Outros Participantes -->
                                    <az-sub-title title="Outros Participantes" class="mt-3" id="rateio-outros-participantes">
                                        <a class="card-link" v-if="!viewonly || rateio.fl_especifico" href="#" @click.prevent="incluirParticipante (rateio)">
                                            <i class="fas fa-plus mr-2"></i>
                                            Incluir Outro Participante
                                        </a>
                                    </az-sub-title>
                                    <div class="form-row" v-for="(outro, iox) in lista_outros_participantes" :key="iox">
                                        <div class="col col-12 col-md-4">
                                            <az-input
                                                sizing="sm"
                                                icon="fas fa-minus"
                                                :buttonIcon="true"
                                                buttonText="fas fa-minus"
                                                @clickButton="remover_ativo_item(outro)"
                                                buttonColor="outline-danger"
                                                type="select"
                                                optionsMode="aql"
                                                optionsData="id_pessoa"
                                                service="medicos.index"
                                                required 
                                                :validate="validate"
                                                v-model="outro.id_medico" />
                                        </div>
                                        <div class="col col-12 col-md-2">
                                            <az-input
                                                sizing="sm"
                                                type="select"
                                                placeholder="Selecione..."
                                                :validate="validate"
                                                :optionsList="[
                                                    { id: 0, search: 'Percentual' }, 
                                                    { id: 1, search: 'Valor Fixo Único' },
                                                    { id: 2, search: 'Valor Fixo (x Qtd)' },
                                                ]"
                                                optionsData="id"
                                                v-model="outro.fl_valor_fixo" />
                                        </div>
                                        <div class="col col-12 col-md-2" v-if="!outro.fl_valor_fixo">
                                            <az-input
                                                sizing="sm"
                                                icon="fas fa-percent fa-fw"
                                                :type="removendo_item ? 'number' : 'money'"
                                                required 
                                                :validate="validate"
                                                v-model="outro.dc_porcentagem_medico" />
                                        </div>
                                        <div class="col col-12 col-md-2" v-else>
                                            <az-input
                                                sizing="sm"
                                                icon="fa-solid fa-brazilian-real-sign fa-fw"
                                                :type="removendo_item ? 'number' : 'money'"
                                                required 
                                                :validate="validate"
                                                v-model="outro.dc_valor_fixo" />
                                        </div>
                                        <div class="col col-12 col-md-4">
                                            <az-input
                                                sizing="sm"
                                                type="text"
                                                placeholder="Descrição..."
                                                :validate="validate"
                                                v-model="outro.st_titulo" />
                                        </div>
                                    </div>

                                    <div class="row" v-if="!lista_outros_participantes.length">
                                        <div class="col col-12">
                                            <span class="text-muted">
                                                Nenhum
                                            </span>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            <!-- Comissão -->

                            <div class="card" v-if="tem_comissao">
                                <div class="card-header alert-info">
                                    <a class="card-link" data-toggle="collapse" href="#collapseComissaoFiltros">
                                        Comissão
                                    </a>
                                </div>
                                <div class="card-body collapse show" id="collapseComissaoFiltros">
                                    <div class="form-row">
                                        <div class="col col-12 col-md-6">
                                            <az-input
                                                type="select"
                                                label="Tipo"
                                                sizing="sm"
                                                :validate="validate"
                                                optionsData="id"
                                                :optionsList="[
                                                    { id: null, search: 'Percentual' }, 
                                                    // { id: 1, search: 'Valor Fixo por Atendimento' }, 
                                                    { id: 2, search: 'Valor Fixo por Procedimento' }, 
                                                    { id: 3, search: 'Valor Fixo por Procedimento (x Qtd)' }, 
                                                ]"
                                                v-model="rateio.fl_comissao_fixo" />
                                        </div>

                                        <div class="col col-12 col-md-6">
                                            <az-input
                                                v-if="rateio.fl_comissao_fixo || rateio.fl_comissao_consumo"
                                                type="select"
                                                label="Repasse Sobre Mat/Med/Taxa"
                                                sizing="sm"
                                                :validate="validate"
                                                optionsData="id"
                                                :optionsList="[
                                                    { id: 1, search: 'Nenhum' }, 
                                                    { id: null, search: 'Com Procedimento' },
                                                    { id: 3, search: 'Definido por Item' }, 
                                                ]"
                                                v-model="rateio.ch_solic_consumo" />
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="col col-12 col-md-6">
                                            <az-input
                                                :label="
                                                    rateio.fl_comissao_fixo 
                                                        ? 'Valor Fixo'
                                                        : ( 'Comissão para ' + ( rateio.st_comissao_destino == 'S' ? 'Solicitante' : ( rateio.st_comissao_destino == 'I' ? 'Indicador' : 'Solicitante / Indicador' ) ) )"
                                                sizing="sm"
                                                type="money"
                                                :validate="validate"
                                                v-model="rateio.dc_comissao_solicitante">
                                                <template v-slot:button-pre v-if="rateio.fl_comissao_fixo">
                                                    <div class="input-group-prepend">
                                                        <span class="input-group-text" id="basic-addon2">
                                                            R$
                                                        </span>
                                                    </div>
                                                </template>
                                                <template v-slot:buttonposb v-else>
                                                    <div class="input-group-append">
                                                        <span class="input-group-text" id="basic-addon2">
                                                            <i class="fa fa-percent" aria-hidden="true"></i>
                                                        </span>
                                                    </div>
                                                </template>
                                            </az-input>
                                        </div>
                                        <div class="col col-12 col-md-6">
                                            <az-input
                                                label="Destino"
                                                type="select"
                                                sizing="sm"
                                                placeholder="Destino..."
                                                :optionsList="[
                                                    { id: 'A', search: 'Solicitante / Indicador' }, 
                                                    { id: 'S', search: 'Solicitante' }, 
                                                    { id: 'I', search: 'Indicador' }
                                                ]"
                                                optionsData="id"
                                                :validate="validate"
                                                v-model="rateio.st_comissao_destino">
                                            </az-input>
                                        </div>
                                    </div>
                                    
                                    <div class="form-row mt-2" v-if="!rateio.fl_comissao_fixo">
                                        <div class="col col-12 col-md-6">
                                            <az-input
                                                type="checkbox-group"
                                                label="Comissão pelo valor líquido"
                                                sizing="sm"
                                                :validate="validate"
                                                v-model="rateio.fl_com_liq" />
                                        </div>

                                        <div class="col col-12 col-md-6">
                                            <az-input
                                                type="checkbox-group"
                                                label="Comissão sobre Mat/Med/Taxa"
                                                sizing="sm"
                                                :validate="validate"
                                                v-model="rateio.fl_comissao_consumo" />
                                        </div>
                                    </div>

                                </div>
                            </div>

                            <!-- Revisor de Laudo -->

                            <div class="card" v-if="1==1 || ( rateio.ch_tipo_repasse == 'P' )">
                                <div class="card-header alert-info">
                                    <a class="card-link" data-toggle="collapse" href="#collapseRevisor">
                                        Revisor / Auxiliar
                                    </a>
                                </div>
                                <div class="card-body collapse show" id="collapseRevisor">
                                    <div class="form-row">
                                        <div class="col col-12 col-md-6">
                                            <az-input
                                                type="select"
                                                sizing="sm"
                                                :validate="validate"
                                                optionsData="id"
                                                :optionsList="[
                                                    { id: null, search: 'Percentual' }, 
                                                    // { id: 1, search: 'Valor Fixo por Atendimento' }, 
                                                    { id: 2, search: 'Valor Fixo por Procedimento' }, 
                                                    { id: 3, search: 'Valor Fixo por Procedimento (x Qtd)' }, 
                                                ]"
                                                v-model="rateio.fl_revisor_fixo" />
                                        </div>

                                        <div class="col col-12 col-md-3">
                                            <az-input
                                                sizing="sm"
                                                type="money"
                                                :validate="validate"
                                                v-model="rateio.dc_revisor">
                                                <template v-slot:button-pre v-if="rateio.fl_revisor_fixo">
                                                    <div class="input-group-prepend">
                                                        <span class="input-group-text" id="basic-addon2">
                                                            R$
                                                        </span>
                                                    </div>
                                                </template>
                                                <template v-slot:buttonposb v-else>
                                                    <div class="input-group-append">
                                                        <span class="input-group-text" id="basic-addon2">
                                                            <i class="fa fa-percent" aria-hidden="true"></i>
                                                        </span>
                                                    </div>
                                                </template>
                                            </az-input>
                                        </div>

                                        <div class="col col-12 col-md-3">
                                            <az-input
                                                label="Abater do Profissional"
                                                sizing="sm"
                                                type="checkbox-group"
                                                :validate="validate"
                                                v-model="rateio.fl_revisor_abater">
                                            </az-input>
                                        </div>
                                    </div>

                                    <div class="mt-3" v-if="rateio.revisores">
                                        <az-sub-title title="Por Revisor">
                                            <a class="card-link" v-if="!viewonly || rateio.fl_especifico" href="#" @click.prevent="incluirRevisor (rateio)">
                                                <i class="fas fa-plus mr-2"></i>
                                                Incluir
                                            </a>
                                        </az-sub-title>
                                        <template v-for="(revisor, irx) in rateio.revisores">
                                            <div class="form-row" v-if="!revisor.excluido" :key="irx">
                                                <div class="col col-12 col-md-3">
                                                    <az-input
                                                        v-if="revisor.id_medico && revisor.id_rateio_medico_revisor"
                                                        sizing="sm"
                                                        :edicao="false"
                                                        v-model="revisor.medico.search">
                                                        <template v-slot:button-pre>
                                                            <div class="input-group-prepend">
                                                                <button type="button" class="btn btn-outline-danger" @click="revisor.excluido = true">
                                                                    <i class="fa fa-minus" aria-hidden="true"></i>
                                                                </button>
                                                            </div>
                                                        </template>
                                                    </az-input>

                                                    <az-input
                                                        v-else
                                                        sizing="sm"
                                                        type="select"
                                                        optionsMode="aql"
                                                        optionsData="id_pessoa"
                                                        service="medicos.index"
                                                        required 
                                                        :validate="validate"
                                                        v-model="revisor.id_medico">
                                                        <template v-slot:button-pre>
                                                            <div class="input-group-prepend">
                                                                <button type="button" class="btn btn-outline-danger" @click="remover_item(rateio.revisores, irx)">
                                                                    <i class="fa fa-minus" aria-hidden="true"></i>
                                                                </button>
                                                            </div>
                                                        </template>
                                                    </az-input>
                                                </div>
                                                <div class="col col-12 col-md-3">
                                                    <az-input
                                                        type="select"
                                                        sizing="sm"
                                                        :validate="validate"
                                                        optionsData="id"
                                                        :optionsList="[
                                                            { id: null, search: 'Percentual' }, 
                                                            // { id: 1, search: 'Valor Fixo por Atendimento' }, 
                                                            { id: 2, search: 'Valor Fixo por Procedimento' }, 
                                                            { id: 3, search: 'Valor Fixo por Procedimento (x Qtd)' }, 
                                                        ]"
                                                        v-model="revisor.fl_revisor_fixo" />
                                                </div>

                                                <div class="col col-12 col-md-3">
                                                    <az-input
                                                        sizing="sm"
                                                        type="money"
                                                        :validate="validate"
                                                        v-model="revisor.dc_revisor">
                                                        <template v-slot:button-pre v-if="revisor.fl_revisor_fixo">
                                                            <div class="input-group-prepend">
                                                                <span class="input-group-text" id="basic-addon2">
                                                                    R$
                                                                </span>
                                                            </div>
                                                        </template>
                                                        <template v-slot:buttonposb v-else>
                                                            <div class="input-group-append">
                                                                <span class="input-group-text" id="basic-addon2">
                                                                    <i class="fa fa-percent" aria-hidden="true"></i>
                                                                </span>
                                                            </div>
                                                        </template>
                                                    </az-input>
                                                </div>

                                                <div class="col col-12 col-md-3">
                                                    <az-input
                                                        label="Abater do Profissional"
                                                        sizing="sm"
                                                        type="checkbox-group"
                                                        :validate="validate"
                                                        v-model="revisor.fl_revisor_abater">
                                                    </az-input>
                                                </div>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                            </div>

                            <!-- FILTROS -->

                            <div class="card">
                                <div class="card-header alert-info">
                                    <a class="card-link" data-toggle="collapse" href="#collapseFiltros">
                                        Filtros de Aplicação da Regra
                                    </a>
                                </div>
                                <div class="card-body collapse show" id="collapseFiltros">
                                    <!-- Restrição para Paicentes -->
                                    <div class="form-row">
                                        <div class="col col-12 col-md-4">
                                            <az-input
                                                sizing="sm"
                                                type="number"
                                                label="Idade Mínima do Paciente"
                                                placeholder="0"
                                                v-model="rateio.in_idade_min" />
                                        </div>
                                        <div class="col col-12 col-md-4">
                                            <az-input
                                                sizing="sm"
                                                type="number"
                                                label="Idade Máxima do Paciente"
                                                placeholder="999"
                                                v-model="rateio.in_idade_max" />
                                        </div>
                                        <div class="col col-12 col-md-4">
                                            <az-input
                                                sizing="sm"
                                                type="sexo"
                                                placeholder="Qualquer"
                                                label="Sexo do Paciente"
                                                v-model="rateio.ch_sexo" />
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="col col-12 col-md-4">
                                            <az-input
                                                sizing="sm"
                                                label="Tipo de Agenda"
                                                type="select"
                                                :optionsList="[
                                                    { id: 'T', search: 'Qualquer Agenda' },
                                                    { id: 'S', search: 'Apenas Agendas Eventuais' },
                                                    { id: 'N', search: 'Apenas Agendas Não Eventuais' }
                                                ]"
                                                optionsData="id"
                                                v-model="rateio.ch_agenda_eventual" />
                                        </div>

                                        <div class="col col-12 col-md-4">
                                            <az-input
                                                sizing="sm"
                                                label="Cooperado"
                                                type="select"
                                                :optionsList="[
                                                    { id: 'T', search: 'Geral' },
                                                    { id: 'S', search: 'Apenas Cooperados' },
                                                    { id: 'N', search: 'Apenas Não Cooperados' }
                                                ]"
                                                optionsData="id"
                                                v-model="rateio.ch_cooperado" />
                                        </div>
                                    </div>

                                    <!-- Dias da Semana -->
                                    <div class="form-row my-3">
                                        <div class="col col-12 d-flex flex-column">
                                            <div class="btn-group input-group-sm" role="group" aria-label="Basic example">
                                                <button type="button" class="btn btn-sm" 
                                                    :class=" ( rateio.js_dias && rateio.js_dias[dia - 1] === false ) ? 'btn-outline-secondary' : 'btn-secondary'"  
                                                    @click="toggle_dia(dia - 1)" v-for="dia in 7" :key="dia">
                                                    {{ nome_dia(dia - 1) }}
                                                    <i class="fa fa-times ml-2" v-if="rateio.js_dias && rateio.js_dias[dia - 1] === false" aria-hidden="true"></i>
                                                    <i class="fa fa-check ml-2" v-else aria-hidden="true"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Faixa de Horário -->
                                    <div class="form-row mb-3">
                                        <div class="col col-12 col-md-4">
                                            <az-input
                                                sizing="sm"
                                                type="checkbox-group"
                                                label="Faixa de Horário"
                                                v-model="rateio.por_horario" />
                                        </div>
                                        <div class="col col-12 col-md-4" v-if="rateio.por_horario">
                                            <az-input
                                                sizing="sm"
                                                type="time"
                                                icon="fa-solid fa-greater-than-equal fa-fw"
                                                required
                                                :validate="validate"
                                                v-model="rateio.hr_inicio" />
                                        </div>
                                        <div class="col col-12 col-md-4" v-if="rateio.por_horario">
                                            <az-input
                                                sizing="sm"
                                                type="time"
                                                icon="fa-solid fa-less-than-equal fa-fw"
                                                required
                                                :validate="validate"
                                                v-model="rateio.hr_termino" />
                                        </div>
                                    </div>

                                    <!-- Filtros -->
                                    <az-sub-title title="Filtros" class="mt-2">
                                        <div class="row" v-if="!viewonly">
                                            <div class="col col-12">
                                                <a type="button" class="card-link" @click="incluir_filtro(rateio)">
                                                    <i class="fas fa-plus mr-2"></i>
                                                    Incluir Filtro
                                                </a>
                                            </div>
                                        </div>
                                    </az-sub-title>
                                    <div class="mt-2" id="rateio-filtros">
                                        <div class="form-row" v-for="(filtro, ifx) in lista_filtros" :key="ifx">
                                            <div class="col col-12 col-md-3">
                                                <az-input
                                                    sizing="sm"
                                                    type="button-group"
                                                    :optionsList="[{id:1,search:'Apenas'}, {id:0,search:'Exceto'}]"
                                                    :validate="validate"
                                                    v-model="filtro.fl_regra" />
                                            </div>
                                            <div class="col col-12 col-md-3">
                                                <az-input
                                                    sizing="sm"
                                                    type="select"
                                                    optionsMode="json"
                                                    :optionsList="lista_opcoes_proced_filtro"
                                                    optionsData="id"
                                                    :validate="validate"
                                                    :edicao="!( filtro.model_id && filtro.model ) && !( filtro.tipo_filtro && filtro.tipo_filtro.slice(0,3) == 'tag' && filtro.id_rateio_medico_filtro && filtro.st_hashtag )"
                                                    required
                                                    v-model="filtro.tipo_filtro">
                                                    <template v-slot:button-pre>
                                                        <div class="input-group-prepend">
                                                            <button class="btn btn-outline-danger" type="button" @click="filtro.excluido = true">
                                                                <i class="fa fa-minus" aria-hidden="true"></i>
                                                            </button>
                                                        </div>
                                                    </template>
                                                </az-input>                                
                                            </div>
                                            <div class="col col-12 col-md-6">
                                                <div class="input-group-sm" v-if="!filtro.tipo_filtro">
                                                    <input type="text" placeholder="..." class="form form-control" disabled>
                                                </div>
                                                <az-input
                                                    sizing="sm"
                                                    v-else-if="filtro.tipo_filtro.slice(0,3) == 'tag' && filtro.id_rateio_medico_filtro && filtro.st_hashtag"
                                                    placeholder
                                                    :edicao="false"
                                                    v-model="filtro.st_hashtag" />
                                                <az-input
                                                    sizing="sm"
                                                    v-else-if="filtro.tipo_filtro == 'tag-medico'"
                                                    placeholder
                                                    type="select" 
                                                    optionsMode="aql"
                                                    :optionsList="lista_tag_medicos"
                                                    optionsData="id"
                                                    required 
                                                    v-model="filtro.st_hashtag" />
                                                <az-input
                                                    sizing="sm"
                                                    v-else-if="filtro.tipo_filtro == 'tag-solicitante'"
                                                    placeholder
                                                    type="select" 
                                                    optionsMode="aql"
                                                    :optionsList="lista_tag_solicitantes"
                                                    optionsData="id"
                                                    required 
                                                    v-model="filtro.st_hashtag" />
                                                <az-input
                                                    sizing="sm"
                                                    v-else-if="filtro.tipo_filtro == 'tag-material'"
                                                    placeholder
                                                    type="select" 
                                                    optionsMode="aql"
                                                    :optionsList="lista_tag_materiais"
                                                    optionsData="id"
                                                    required 
                                                    v-model="filtro.st_hashtag" />
                                                <az-input
                                                    sizing="sm"
                                                    v-else-if="filtro.tipo_filtro == 'tag-medicamento'"
                                                    placeholder
                                                    type="select" 
                                                    optionsMode="aql"
                                                    :optionsList="lista_tag_medicamentos"
                                                    optionsData="id"
                                                    required 
                                                    v-model="filtro.st_hashtag" />
                                                <az-input
                                                    sizing="sm"
                                                    v-else-if="filtro.tipo_filtro == 'tag-plano'"
                                                    placeholder
                                                    type="select" 
                                                    optionsMode="aql"
                                                    :optionsList="lista_tag_planos"
                                                    optionsData="id"
                                                    required 
                                                    v-model="filtro.st_hashtag" />
                                                <az-input
                                                    sizing="sm"
                                                    v-else-if="filtro.tipo_filtro == 'tag-operadora'"
                                                    placeholder
                                                    type="select" 
                                                    optionsMode="aql"
                                                    :optionsList="lista_tag_operadoras"
                                                    optionsData="id"
                                                    required 
                                                    v-model="filtro.st_hashtag" />
                                                <az-input
                                                    sizing="sm"
                                                    v-else-if="filtro.tipo_filtro == 'tag-procedimento'"
                                                    placeholder
                                                    type="select" 
                                                    optionsMode="aql"
                                                    :optionsList="lista_tag_procedimentos"
                                                    optionsData="id"
                                                    required 
                                                    v-model="filtro.st_hashtag" />
                                                <az-input
                                                    v-else-if="filtro.model_id && filtro.model"
                                                    sizing="sm"
                                                    :edicao="false"
                                                    v-model="filtro.model.search">
                                                    <template v-slot:buttonposb>
                                                        <div class="input-group-append">
                                                            <div class="input-group-text" v-if="filtro.model_type == 'App\\azure\\medicoUnidade'">
                                                                #{{ filtro.model.id_medico }}
                                                            </div>
                                                            <div class="input-group-text" v-else>
                                                                #{{ filtro.model_id }}
                                                            </div>
                                                        </div>
                                                    </template>
                                                </az-input>
                                                <az-input
                                                    sizing="sm"
                                                    v-else-if="serviceFiltro(filtro.tipo_filtro)"
                                                    placeholder
                                                    type="autocomplete" 
                                                    optionsMode="aql"
                                                    :service="serviceFiltro(filtro.tipo_filtro)" 
                                                    :optionsName="'filtro-' + filtro.tipo_filtro"
                                                    :optionsParm="{ ativos: true, filtros: true }"
                                                    :optionsSync="syncFiltro(filtro.tipo_filtro)"
                                                    required 
                                                    v-model="filtro.model" /> <!-- agenda: true, -->
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row" v-if="!lista_filtros.length">
                                        <div class="col col-12">
                                            <span class="text-muted">
                                                Nenhum
                                            </span>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header alert-info">
                                    <a class="card-link" data-toggle="collapse" href="#collapseConsumoFiltros">
                                        Filtros de Repasse de Mat/Med/Taxa do Procedimento
                                    </a>
                                </div>
                                <div class="card-body collapse show" id="collapseConsumoFiltros">
                                    
                                    <!-- Filtros -->
                                    <az-sub-title title="Filtros" class="mt-2">
                                        <div class="row" v-if="!viewonly">
                                            <div class="col col-12">
                                                <a type="button" class="card-link" @click="incluir_filtro(rateio, true)">
                                                    <i class="fas fa-plus mr-2"></i>
                                                    Incluir Filtro
                                                </a>
                                            </div>
                                        </div>
                                    </az-sub-title>
                                    <div class="mt-2" id="rateio-filtros">
                                        <div class="form-row" v-for="(filtro, ifx) in lista_matmed_filtros" :key="ifx">
                                            <div class="col col-12 col-md-3">
                                                <az-input
                                                    sizing="sm"
                                                    type="button-group"
                                                    :optionsList="[{id:1,search:'Apenas'}, {id:0,search:'Exceto'}]"
                                                    :validate="validate"
                                                    v-model="filtro.fl_regra" />
                                            </div>
                                            <div class="col col-12 col-md-3">
                                                <az-input
                                                    sizing="sm"
                                                    type="select"
                                                    optionsMode="json"
                                                    :optionsList="lista_opcoes_matmed_filtro"
                                                    optionsData="id"
                                                    :validate="validate"
                                                    :edicao="!( filtro.model_id && filtro.model )"
                                                    required
                                                    v-model="filtro.tipo_filtro">
                                                    <template v-slot:button-pre>
                                                        <div class="input-group-prepend">
                                                            <button class="btn btn-outline-danger" type="button" @click="filtro.excluido = true">
                                                                <i class="fa fa-minus" aria-hidden="true"></i>
                                                            </button>
                                                        </div>
                                                    </template>
                                                </az-input>                                
                                            </div>
                                            <div class="col col-12 col-md-6">
                                                <div class="input-group-sm" v-if="!filtro.tipo_filtro">
                                                    <input type="text" placeholder="..." class="form form-control" disabled>
                                                </div>
                                                <az-input
                                                    sizing="sm"
                                                    v-else-if="filtro.tipo_filtro == 'tag-material'"
                                                    placeholder
                                                    type="select" 
                                                    optionsMode="aql"
                                                    :optionsList="lista_tag_materiais"
                                                    optionsData="id"
                                                    required 
                                                    v-model="filtro.st_hashtag">
                                                    <template v-slot:buttonposb>
                                                        <div class="input-group-append">
                                                            <div class="input-group-text" v-if="filtro.st_hashtag">
                                                                {{ filtro.st_hashtag }}
                                                            </div>
                                                        </div>
                                                    </template>
                                                </az-input>
                                                <az-input
                                                    sizing="sm"
                                                    v-else-if="filtro.tipo_filtro == 'tag-medicamento'"
                                                    placeholder
                                                    type="select" 
                                                    optionsMode="aql"
                                                    :optionsList="lista_tag_medicamentos"
                                                    optionsData="id"
                                                    required 
                                                    v-model="filtro.st_hashtag">
                                                    <template v-slot:buttonposb>
                                                        <div class="input-group-append">
                                                            <div class="input-group-text" v-if="filtro.st_hashtag">
                                                                {{ filtro.st_hashtag }}
                                                            </div>
                                                        </div>
                                                    </template>
                                                </az-input>
                                                <az-input
                                                    v-else-if="filtro.model_id && filtro.model"
                                                    sizing="sm"
                                                    :edicao="false"
                                                    v-model="filtro.model.search">
                                                    <template v-slot:buttonposb>
                                                        <div class="input-group-append">
                                                            <div class="input-group-text" v-if="filtro.model_type == 'App\\azure\\medicoUnidade'">
                                                                #{{ filtro.model.id_medico }}
                                                            </div>
                                                            <div class="input-group-text" v-else>
                                                                #{{ filtro.model_id }}
                                                            </div>
                                                        </div>
                                                    </template>
                                                </az-input>
                                                <az-input
                                                    sizing="sm"
                                                    v-else-if="serviceFiltro(filtro.tipo_filtro)"
                                                    placeholder
                                                    type="autocomplete" 
                                                    optionsMode="aql"
                                                    :service="serviceFiltro(filtro.tipo_filtro)" 
                                                    :optionsName="'filtro-' + filtro.tipo_filtro"
                                                    :optionsParm="{ ativos: true, filtros: true }"
                                                    :optionsSync="syncFiltro(filtro.tipo_filtro)"
                                                    required 
                                                    v-model="filtro.model" /> <!-- agenda: true, -->
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row" v-if="!lista_matmed_filtros.length">
                                        <div class="col col-12">
                                            <span class="text-muted">
                                                Nenhum filtro para o repasse de Mat/Med/Taxa do procedimento.
                                            </span>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            <!-- Zoop -->
                            <div class="card" v-if="rateio.zoop">
                                <div class="card-header alert-info">
                                    <a class="card-link" data-toggle="collapse" href="#collapseZoop">
                                        Zoop
                                    </a>
                                </div>
                                <div class="card-body collapse show" id="collapseZoop">
                                    <div class="form-row">
                                        <div class="col col-12">
                                            <az-input
                                                label="Split/NF por Outra Unidade"
                                                type="select"
                                                placeholder="Não..."
                                                :optionsList="$util.unidades_com_tags(false, false)"
                                                optionsData="id_unidade_operacao"
                                                v-model="rateio.id_unidade_operacao_nf" />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Observações -->
                            <div class="card">
                                <div class="card-header alert-info">
                                    <a class="card-link" data-toggle="collapse" href="#collapseObs">
                                        Observações
                                    </a>
                                </div>
                                <div class="card-body collapse show" id="collapseObs">
                                    <div class="form-row">
                                        <div class="col col-12">
                                            <az-input
                                                type="textarea"
                                                placeholder="Observações..."
                                                v-model="rateio.st_obs" />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Depreciado -->                            
                            <div class="form-row" v-if="rateio.rateio_medico_operadoras.length">

                                <div class="col col-12 col-md-4">
                                    <az-input
                                        sizing="sm"
                                        :icon="rateio.ch_operadoras_lista == 'R' ? 'fas fa-folder-plus' : (
                                            rateio.ch_operadoras_lista == 'E' ? 'fas fa-folder-minus' : 'fas fa-folder'
                                        )"
                                        type="select"
                                        optionsMode="json"
                                        optionsData="id"
                                        :optionsList="[{id:'T',search:'Todas'},{id:'R',search:'Apenas'},{id:'E',search:'Exceto'}]"
                                        required 
                                        :validate="validate"
                                        v-model="rateio.ch_operadoras_lista" />
                                </div>

                                <template v-if="rateio.ch_operadoras_lista && rateio.ch_operadoras_lista != 'T'">
                                
                                    <div class="col col-12 col-md-4">
                                        <az-input
                                            sizing="sm"
                                            :icon="rateio.ch_operadoras_lista == 'E' ? 'fas fa-minus' : 'fas fa-plus'"
                                            type="select"
                                            optionsMode="aql"
                                            optionsName="operadoras.index.rateio"
                                            :optionsReload="true"
                                            service="operadoras.index"
                                            v-model="rateioNovaOperadora"
                                            @input="adicionarRateioOperadora ()" />
                                    </div>

                                    <div class="col col-12 col-md-4" v-for="(rmo, irmo) in rateio.rateio_medico_operadoras" :key="irmo">
                                        <az-input 
                                            sizing="sm"
                                            type="checkbox-group"
                                            :label="rmo.search"
                                            v-model="rmo.selecionado" />
                                    </div>

                                    <div class="col col-12 col-md-4" v-if="!rateio.rateio_medico_operadoras || !rateio.rateio_medico_operadoras.length">
                                        <az-input 
                                            sizing="sm"
                                            :edicao="false"
                                            value="Todas" />
                                    </div>

                                </template>

                            </div>

                            <pre v-if="false">{{ rateio }}</pre>

                        </template>

                        
                        <br><br><br><br><br>

                    </div>
                    <div class="modal-footer" v-if="rateio">
                        <a href="#" class="card-link mr-3" @click.prevent="tour()">
                            <i class="far fa-compass fa-2x"></i>
                        </a>

                        <button class="btn btn-outline-primary mr-1" type="button" @click="toggle_compress()" data-toggle="tooltip" data-placement="top" title="Comprimir/Expandir">
                            <i class="fa-solid fa-minimize"></i>
                        </button>

                        <button class="btn btn-outline-primary mr-1" type="button" @click="download()" data-toggle="tooltip" data-placement="top" title="Download">
                            <i class="fas fa-download"></i>
                        </button>
                        <button class="btn btn-outline-primary mr-2" type="button" @click="upload()" data-toggle="tooltip" data-placement="top" title="Upload" v-if="!rateio.id_rateio_medico">
                            <i class="fas fa-upload"></i>
                        </button>

                        <az-audit-log-button v-if="rateio && rateio.id_rateio_medico" model="rateioMedico" :id="rateio.id_rateio_medico" />
                        <az-submit color="outline-danger" @click="removerRateio ()" v-if="false && !viewonly && rateio.id_rateio_medico">Remover</az-submit>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit v-if="!viewonly || rateio.fl_especifico" @click="atualizarRateio ()">
                            {{ rateio.id_rateio_medico ? 'Atualizar' : 'Incluir' }}
                        </az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';

export default {
    data() { 
        return { 
            rateio: null, 
            validate: false, 
            rateioNovaOperadora: null, 
            id_medico: null, 
            config_repasse_misto_cache: null,
            lista_tag_medicos: [], 
            lista_tag_planos: [], 
            lista_tag_materiais: [],
            lista_tag_medicamentos: [], 
            lista_tag_solicitantes: [], 
            lista_tag_procedimentos: [], 
            removendo_item: false, 
            config_comissao: false, 
        }
    },

    props: ['viewonly', 'modalname'],

    components: { 
        AzInput,
        AzSubmit,
        AzEmptyState,
        AzSubTitle,
        AzAuditLogButton,
    },

    computed: { 
        tem_comissao: function () { 
            return window.redir == 'teste' || window.redir == 'labs' || this.config_comissao;
        },

        modal_name: function () { 
            return 'editarRateioModal' + this.modalname;
        },

        tem_grau: function () { 
            if ( !this.lista_filtros ) { 
                return false;
            }

            return this.lista_filtros.find(item => item.model_type == 'App\\azure\\grauParticipacao') ? true : false;
        },

        lista_tipo_criterio: function () { 

            let lista = [
                { id: 'P', search: 'Produzido' }, 
                { id: 'F', search: 'Faturado/Pago' }, 
                { id: 'R', search: 'Recebido' },
            ];

            if ( this.rateio && this.rateio.config_repasse_misto ) { 
                lista.push({ id: 'M', search: 'Produzido/Faturado' });
            }

            return lista;

        },
        
        lista_outros_participantes: function () { 
            if ( !this.rateio || !this.rateio.outros_participantes )
                return [];

            return this.rateio.outros_participantes.filter(item => item.fl_ativo);
        }, 

        tipos_matmed: function () { 
            return { 
                'App\\azure\\material': true, 
                'App\\azure\\medicamento': true, 
                'App\\azure\\taxa': true, 
                'tag-material': true, 
                'tag-medicamento': true
            };
        },

        lista_filtros: function () { 

            if ( !this.rateio ) 
                return [];

            return this.rateio.filtros.filter(item => !item.excluido && !item.matmed && !_.get(this.tipos_matmed, item.model_type ? item.model_type : item.st_tipo_tag));

        },

        lista_matmed_filtros: function () { 

            if ( !this.rateio ) 
                return [];

            return this.rateio.filtros.filter(item => !item.excluido && ( item.matmed || _.get(this.tipos_matmed, item.model_type ? item.model_type : item.st_tipo_tag) ));

        },

        lista_opcoes_filtro: function () { 
            let opcoes = [                                
                {id:'App\\azure\\apoiado', search:'Apoiado'}, 
                {id:'App\\azure\\medicoSolicitante', search:'Profissional Solicitante'}, 
                {id:'App\\azure\\classeProcedimento', search:'Classe do Procedimento'}, 
                {id:'App\\azure\\especialidade', search:'Especialidade'}, 
                {id:'App\\azure\\grauParticipacao', search:'Grau de Participação'},
                {id:'App\\azure\\material', search:'Material'},
                {id:'App\\azure\\medicamento', search:'Medicamento'},
                {id:'App\\azure\\taxa', search:'Taxa'},
                {id:'App\\azure\\operadora', search:'Operadora'}, 
                {id:'App\\azure\\plano', search:'Operadora/Plano'}, 
                {id:'tag-plano', search:'Classificação do Plano Particular'},
                {id:'App\\azure\\procedimento', search:'Procedimento'},
                {id:'App\\azure\\recepcao', search:'Recepção', service: 'recepcaos.index', parms: { filtros: true }},
                {id:'tag-material', search:'Classificação do Material'},
                {id:'tag-medicamento', search:'Classificação do Medicamento'},
                {id:'tag-solicitante', search:'Classificação do Solicitante'},
                {id:'tag-procedimento', search:'Classificação do Procedimento'},
            ];

            if ( this.lista_filtros && this.lista_filtros.find(item => item.model_type == 'App\\azure\\medicoUnidade' || item.model_type == 'App\\azure\\grauParticipacao') ) { 
                opcoes.push({id:'App\\azure\\medicoUnidade', search:'Prestador Principal', service: 'medico_unidades.index', parms: { filtros: true }});
            }

            if ( !this.id_medico ) { 
                opcoes.push({id:'App\\azure\\medico', search:'Prestador'});
                opcoes.push({id:'tag-medico', search:'Classificação do Prestador'});
            }

            if ( this.$store.state.unidade.unidade_operacaos.length > 1 ) { 
                opcoes.push({id:'App\\azure\\unidadeOperacao', search:'Unidade'});
            }
            
            return _.orderBy(opcoes, 'search');
        },

        lista_opcoes_proced_filtro: function () { 
            return this.lista_opcoes_filtro.filter(filtro => !_.get(this.tipos_matmed, filtro.id));
        },

        lista_opcoes_matmed_filtro: function () { 
            return this.lista_opcoes_filtro.filter(filtro => _.get(this.tipos_matmed, filtro.id));
        },

        lista_tag_consumo: function() { 
            if ( !this.lista_tag_materiais || !this.lista_tag_medicamentos ) 
                return [];

            return _.orderBy(
                _.uniqBy(this.lista_tag_materiais.concat(this.lista_tag_medicamentos), 'id'),
                'search'
            );
        }
    },

    methods: { 
        incluirRevisor (rateio) { 
            rateio.revisores.push({ 
                id_rateio_medico_revisor: null,
                id_rateio_medico: "",
                id_medico: "", 
                fl_revisor_fixo: null, 
                dc_revisor: 0, 
                fl_revisor_abater: false, 
                excluido: false, 
            });
        },

        toggle_compress () { 
            $('#' + this.modal_name + ' .collapse').collapse('toggle');
        },

        toggle_dia (dia) { 
            if ( !this.rateio.js_dias ) { 
                this.rateio.js_dias = [true, true, true, true, true, true, true];
            }

            this.rateio.js_dias[dia] = !this.rateio.js_dias[dia];
            this.$forceUpdate();
        },

        nome_dia(dia) { 
            switch (dia) {
                case 0: return 'Dom';
                case 1: return 'Seg';
                case 2: return 'Ter';
                case 3: return 'Qua';
                case 4: return 'Qui';
                case 5: return 'Sex';
                case 6: return 'Sab';
            }

            return '?';
        },

        upload(adicionar = false) { 
            $('[data-toggle="tooltip"]').tooltip('hide');

            var downloadAnchorNode = document.createElement('input');
            downloadAnchorNode.setAttribute("type", "file");
            downloadAnchorNode.setAttribute("class", "d-none");
            downloadAnchorNode.onchange = () => { this.posUpload(downloadAnchorNode, adicionar); };
            document.body.appendChild(downloadAnchorNode); 
            downloadAnchorNode.click();
        },

        posUpload(el) { 
            var file = el.files[0];

            if (file) {

                var reader = new FileReader();

                reader.readAsText(file, "UTF-8");
        
                reader.onload = (evt) => {
                    let json = JSON.parse(evt.target.result);

                    if ( !json.hasOwnProperty('id_rateio_medico') ) { 
                        this.$toast.add({
                            severity: "error",
                            summary: "Atenção",
                            detail: "Arquivo inválido.",
                            life: 3000
                        });
                        return;
                    }

                    json.id_medico = this.rateio.id_medico;

                    this.rateio = null;

                    this.$nextTick(() => { 
                        this.rateio = json;
                    });
                }

                reader.onerror = function () {
                    this.$toast.add({
                        severity: "error",
                        summary: "Atenção",
                        detail: "Falha lendo arquivo.",
                        life: 3000
                    });
                }

            }
        },

        download () { 
            let info = _.cloneDeep(this.rateio);

            info.id_rateio_medico = null;
            info.id_rateio_mae = null;

            let listas = [
                { 
                    'lista': 'filtros',
                    'chave': 'id_rateio_medico_filtro',
                },
                { 
                    'lista': 'outros_participantes',
                    'chave': 'id_rateio_medico_outro_participante',
                },
                { 
                    'lista': 'rateio_medico_operadoras',
                    'chave': 'id_rateio_medico_operadora',
                },
                { 
                    'lista': 'rateio_medico_fixos',
                    'chave': 'id_rateio_medico_fixo',
                },
            ];

            listas.forEach(item => { 
                if ( info[item.lista] && info[item.lista].length ) { 
                    info[item.lista].forEach(item2 => { 
                        item2[item.chave] = null;
                        item2.id_rateio_medico = null;
                    });
                }
            });

            $('[data-toggle="tooltip"]').tooltip('hide');
            
            var dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(info));
            var downloadAnchorNode = document.createElement('a');
            downloadAnchorNode.setAttribute("href",     dataStr);
            downloadAnchorNode.setAttribute("download", "rateio" + this.rateio.id_rateio_medico + ".json");
            document.body.appendChild(downloadAnchorNode); 
            downloadAnchorNode.click();
            downloadAnchorNode.remove();
        },

        incluirRegraFixo (rateio) { 
            rateio.rateio_medico_fixos.push({ 
                id_rateio_medico_fixo: null,
                id_rateio_medico: rateio.id_rateio_medico,
                id_procedimento: "", 
                dc_valor_fixo: 0,
                excluido: false, 
            });
        },

        incluirRegraFixoConsumo (rateio) { 
            rateio.rateio_medico_fixo_consumos.push({ 
                id_rateio_medico_fixo_consumo: null,
                id_rateio_medico: rateio.id_rateio_medico,
                ch_tipo: "I", 
                search: "",
                consumo: "", 
                ch_tipo_calc: 'V', 
                dc_valor: 0,
                ch_tipo_calc_solic: 'V', 
                dc_valor_solic: 0,
                st_classe: "", 
                excluido: false, 
            });
        }, 

        remover_item(lista, index) { 
            this.removendo_item = true;

            this.$nextTick(() => { 
                lista.splice(index, 1);
                this.removendo_item = false;
            });
        },

        remover_ativo_item(item) { 
            this.removendo_item = true;

            this.$nextTick(() => { 
                item.fl_ativo = false; 
                this.removendo_item = false;
            });
        },

        incluirRegraRetencao (rateio) { 
            if ( !rateio.js_ret_imp_forma ) { 
                rateio.js_ret_imp_forma = [];
            }

            rateio.js_ret_imp_forma.push({
                id_forma_pagamento: "", 
                dc_porcentagem_aliquota: 0,      
            });
        },

        tour() { 
            window.scrollTo(0,0);

            // Define the tour!
            var tour = {
                id: "hello-hopscotch",
                i18n: { 
                        doneBtn: "Pronto",
                        nextBtn: "Próximo",
                        prevBtn: "Anterior",
                        skipBtn: "Pular"
                    },
                steps: [
                    {
                        title: "Título",
                        content: "Título que será na lista de rateios e na exibição no repasse.",
                        target: "rateio-titulo",
                        placement: "bottom"
                    },
                    {
                        title: "Data de Início de Vigência",
                        content: "Data a partir da qual esse critério será considerado. Se ele for criado com data de vigência retroativa, é importante realizar o reprocessamento do rateio dos itens já lançados.",
                        target: "rateio-vigencia",
                        placement: "bottom"
                    },
                    {
                        title: "Referência",
                        content: "Referência de data para realização do repasse.",
                        target: "rateio-referencia",
                        placement: "bottom"
                    },
                    {
                        title: "Pacote de Sessão",
                        content: "Marcar essa caixa, se o repasse de sessões será feito a partir da execução de cada sessão. Caso o repasse seja feito pelo pagamento total do pacote, deve-se deixar desmarcada.",
                        target: "rateio-pacote",
                        placement: "bottom"
                    },
                    {
                        title: "% da Alíquota de Retenção",
                        content: "Indicação do percentual que será abatido do valor base do repasse.",
                        target: "rateio-aliquota",
                        placement: "bottom"
                    },
                    {
                        title: "Filtros",
                        content: "Relação dos filtros nos quais essa regra de rateio será aplicada. Podem ser indicados filtros de procedimentos, unidades, operadoras, etc.",
                        target: "rateio-filtros",
                        placement: "bottom"
                    },
                    {
                        title: "Outros Participantes",
                        content: "Caso essa regra indique que devem ser repassados percentuais para outros profissionais, esses devem ser listados aqui.",
                        target: "rateio-outros-participantes",
                        placement: "bottom"
                    },
                ]
            };

            window.hopscotch.startTour(tour);
        },
            
        syncFiltro(model) { 
            switch (model) {
                case 'App\\azure\\plano': return false;
            }
            return true;
        },

        serviceFiltro(model) {
            switch (model) {
                case 'App\\azure\\apoiado': return 'apoiados.index';
                case 'App\\azure\\medicoSolicitante': return 'medico_solicitantes.index';
                case 'App\\azure\\medico': return 'medicos.index';
                case 'App\\azure\\unidadeOperacao': return 'unidade_operacaos.index';
                case 'App\\azure\\operadora': return 'operadoras.index';
                case 'App\\azure\\especialidade': return 'especialidades.index';
                case 'App\\azure\\classeProcedimento': return 'classe_procedimentos.index';
                case 'App\\azure\\procedimento': return 'procedimentos.index';
                case 'App\\azure\\plano': return 'planos.index';
                case 'App\\azure\\recepcao': return 'recepcaos.index';
                case 'App\\azure\\grauParticipacao': return 'grau_participacoes.index';
                case 'App\\azure\\material': return 'materiais.index';
                case 'App\\azure\\medicamento': return 'medicamentos.index';
                case 'App\\azure\\taxa': return 'taxas.index';
                case 'App\\azure\\medicoUnidade': return 'medico_unidades.index';
            }
            return null;
        },

        incluir_filtro(item, matmed = false) { 
            item.filtros.push({ 
                id_rateio_medico_filtro: null, 
                tipo_filtro: "", 
                model_type: "",
                model_id: "",
                model: "", 
                service: "", 
                fl_regra: true, 
                excluido: false, 
                st_hashtag: "", 
                matmed: matmed,
            });

            this.$forceUpdate();
        },

        incluirParticipante (rateio) { 
            rateio.outros_participantes.push({
                id_rateio_medico: null, 
                id_unidade: 1, 
                id_medico: "", 
                fl_ativo: true, 
                dc_porcentagem_medico: 0,
                dc_valor_medico: 0, 
                fl_valor_fixo: 0, 
                dc_valor_fixo: 0, 
                in_regra_ordem: 1,
                ch_operadoras_lista: 'R', 
                valor_fixo: false,
            });
        },

        incluir (id_medico = null) { 
            this.id_medico = id_medico;

            let item = {
                id_medico: id_medico,
                dt_data_vigencia: this.$util.hoje (),
                fl_ativo: true,
                in_dias_para_pagamento: 30, 
                rateio_medico_operadoras: [], 
                ch_operadoras_lista: "T",
                outros_participantes: [], 
                ch_tipo_repasse: 'P',
                filtros: [],
                fl_abater_taxa_cartao: false, 
                fl_abater_filme: false, 
                config_repasse_misto: false, 
                js_ret_imp_forma: [], 
                rateio_medico_fixos: [], 
                st_comissao_destino: "A", 
            };

            this.rateio = null; 
            this.rateioNovaOperadora = null; 
            this.validate = false;
            
            this.$nextTick (() => { 
                this.rateio = _.cloneDeep(item);
                $('#' + this.modal_name).modal('show');

                if ( this.config_repasse_misto_cache !== null ) { 

                    this.rateio.config_repasse_misto = this.config_repasse_misto_cache;

                } else { 

                    this.$util.loadItem(this, { 
                        service: "configuracoes",
                        func: 'index',
                        parms: { 
                            where: { 
                                st_slug: 'repasse-misto-prod-fat',
                                fl_ativo: 1,
                                st_valor: 1,
                            }
                        } 
                    })
                    .then(res => { 
                        this.config_repasse_misto_cache = res && res.length;
                        this.rateio.config_repasse_misto = res && res.length;
                    });

                }
            });
        },

        editar(id_rateio, replicar = false, id_atp = null, id_ape = null) { 
            this.rateio = null;
            this.rateioNovaOperadora = null; 
            this.validate = false;

            $('#' + this.modal_name).modal('show');

            this.$util.load(this, { 
                service: 'rateio_medicos',
                func: 'show',
                parms: { 
                    id: id_rateio,
                    edicao: true, 
                },
                loadTo: res => { 
                    if ( replicar && !res.fl_especifico ) { 
                        res.id_rateio_medico = null;
                        res.id_rateio_mae = null;
                        res.id_atendimento_procedimento = id_atp;
                        res.id_atendimento_procedimento_equipe = id_ape;
                        res.id_medico = null;
                        res.medico = null;
                        res.fl_especifico = true;

                        if ( res.outros_participantes ) { 
                            res.outros_participantes.forEach(op => { 
                                op.id_rateio_outro = null;
                                op.id_rateio_medico = null;
                            });
                        }

                        if ( res.filtros ) { 
                            res.filtros.forEach(flt => { 
                                flt.id_rateio_medico_filtro = null;
                                flt.id_rateio_medico = null;
                            });
                        }

                        if ( res.rateio_medico_fixo_consumos ) { 
                            res.rateio_medico_fixo_consumos.forEach(flt => { 
                                flt.id_rateio_medico_fixo_consumo = null;
                                flt.id_rateio_medico = null;
                            });
                        }

                        if ( res.rateio_medico_fixos ) { 
                            res.rateio_medico_fixos.forEach(flt => { 
                                flt.id_rateio_medico_fixo = null;
                                flt.id_rateio_medico = null;
                            });
                        }

                        if ( res.rateio_medico_operadoras ) { 
                            res.rateio_medico_operadoras.forEach(flt => { 
                                flt.id_rateio_medico_operadora = null;
                                flt.id_rateio_medico = null;
                            });
                        }

                        if ( res.revisores ) { 
                            res.revisores.forEach(flt => { 
                                flt.id_rateio_medico_revisor = null;
                                flt.id_rateio_medico = null;
                            });
                        }
                    }

                    this.rateio = res;
                    this.id_medico = res.id_medico;
                },
            });
        },

        refresh() { 
            this.$emit('refresh');
        },

        atualizarRateio() { 
            this.$util.atualizar (this, { 
                service: 'rateio_medicos', 
                dados: { ...this.rateio }, 
                modal: this.modal_name,
                callback: this.refresh,
            });
        },

        removerRateio () { 
            this.$util.remover (this, { 
                service: 'rateio_medicos', 
                dados: { ...this.rateio }, 
                modal: this.modal_name,
                reload: true, 
                callback: this.refresh, 
            });
        },
    },

    mounted() { 
        if ( !this.viewonly ) { 

            this.$util.loadItem(this, { 
                service: 'medicos',
                func: 'tags', 
            })
            .then(res => { 
                this.lista_tag_medicos = res.map(item => { 
                    return { 
                        id: item,
                        search: item, 
                    };
                });
            });

            this.$util.loadItem(this, { 
                service: 'procedimentos',
                func: 'tags', 
            })
            .then(res => { 
                this.lista_tag_procedimentos = res.map(item => { 
                    return { 
                        id: item,
                        search: item, 
                    };
                });
            });

            this.$util.loadItem(this, { 
                service: 'planos',
                func: 'tags', 
            })
            .then(res => { 
                this.lista_tag_planos = res.map(item => { 
                    return { 
                        id: item,
                        search: item, 
                    };
                });
            });

            this.$util.loadItem(this, { 
                service: 'materiais',
                func: 'tags', 
            })
            .then(res => { 
                this.lista_tag_materiais = res.map(item => { 
                    return { 
                        id: item,
                        search: item, 
                    };
                });
            });

            this.$util.loadItem(this, { 
                service: 'medicamentos',
                func: 'tags', 
            })
            .then(res => { 
                this.lista_tag_medicamentos = res.map(item => { 
                    return { 
                        id: item,
                        search: item, 
                    };
                });
            });

            this.$util.loadItem(this, { 
                service: 'medico_solicitantes',
                func: 'tags', 
            })
            .then(res => { 
                this.lista_tag_solicitantes = res.map(item => { 
                    return { 
                        id: item,
                        search: item, 
                    };
                });
            });

        }

        this.$util.loadItem(this, { 
            service: "configuracoes",
            func: 'index',
            parms: { 
                where: { 
                    st_slug: 'repasse-comissao-solicitante',
                    fl_ativo: 1,
                    st_valor: 1,
                }
            } 
        })
        .then(res => { 
            this.config_comissao = ( res && res.length ) ? true : false;
        });
    }
}
</script>